import React, { useEffect, useState } from 'react'


import styles from '../../css/style.module.css'


import HOC from '../../components/HOC/HOC'
import { Link } from 'react-router-dom';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'
import { UpdateCommissionForUser } from '../../components/Modals/Modals';



const SettingForStaff = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);



    const fetchData = async () => {
        await getApi(endPoints.getallcommission, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch data!'
        });
    };


    useEffect(() => {
        fetchData();
    }, [])






    const routeMapping = {
        'Commission For User': "/setting/commission/user",
        'Commission For Staff': "/setting/commission/staff",
    };



    return (
        <>
            <UpdateCommissionForUser
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                Category={fetchData}
                type='staff'
                data={data.data?.[0]}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Contact Details</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={()=>setShowAddModal(true)}>
                            {/* <FaPlus color='#FFFFFF' /> */}
                            <p>Update Details</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Commission For User', 'Commission For Staff'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'Commission For Staff'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                {loading ? (
                    <div className={styles.loadingnormal}>
                        <img src={img2} alt="Loading" width={100} height={100} />
                    </div>
                ) : (
                    <div className={styles.jobchildcontainer}>
                        <div className={styles.addcontactdetails}>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Commission</label>
                                <input
                                    type="text"
                                    placeholder='Enter the commission'
                                    value={data.data?.[0].commission}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">Discount Type</label>
                                <input
                                    type="text"
                                    placeholder='Enter the discount Type'
                                    value={data.data?.[0].disCountType}
                                />
                            </div>
                            <div className={styles.addjobinputs}>
                                <label htmlFor="">For</label>
                                <input
                                    type="text"
                                    placeholder='Enter the For'
                                    value={data.data?.[0].for}
                                />
                            </div>
                        </div>
                        <div className={styles.addjobinputs}>
                            <label htmlFor="">Description</label>
                            <textarea
                                placeholder='Enter the description'
                                value={data.data?.[0].description}
                            />
                        </div>
                    </div>
                )}
            </div >
        </>
    )
}

export default HOC(SettingForStaff)
